var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4074 37.7665L19.7333 19.4438C19.9469 19.2303 19.9469 18.886 19.7333 18.6725L1.4074 0.351708C1.06301 0.00737603 0.476196 0.251678 0.476196 0.736436V37.3799C0.476196 37.8665 1.06301 38.1089 1.4074 37.7646V37.7665Z",
    fill: "#8850FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5045 19.4458L38.8304 37.7684C39.1748 38.1128 39.7616 37.8685 39.7616 37.3837V0.73837C39.7616 0.25169 39.1748 0.00931098 38.8304 0.353642L20.5045 18.6763C20.291 18.8898 20.291 19.2342 20.5045 19.4477V19.4458Z",
    fill: "#8850FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyer);
export default __webpack_public_path__ + "static/media/Buyer.767f603d593317b517df27ee6d905017.svg";
export { ForwardRef as ReactComponent };